import { Table } from '@dixa/lib-shared-habla';
import { type Table as TanstackTable } from '@tanstack/react-table';
import type { SearchConversationEnriched } from 'lib-search-types';

import type { ConversationsTableFeatures } from '../../../conversationsTable.columns';

export type ConversationsTableConversationPlaceholderRowsProps = {
  /** The table whose columns get a placeholder cell. */
  table: TanstackTable<ConversationsTableFeatures, SearchConversationEnriched>;
};

export const ConversationsTableConversationPlaceholderRows = ({
  table,
}: ConversationsTableConversationPlaceholderRowsProps): JSX.Element => {
  const columns = table.getVisibleLeafColumns();

  const height =
    table.options.meta?.layout?.density === 'compact' ? '41px' : '65px';

  return (
    <>
      {Array.from({ length: 30 }).map((_, index) => (
        <Table.Tr key={index}>
          {columns.map((column) => (
            <Table.Td key={column.id} height={height}>
              {column.columnDef.meta?.placeholder?.cell}
            </Table.Td>
          ))}
        </Table.Tr>
      ))}
    </>
  );
};
